import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../contexts/app_context';
import { useUserContext } from '../../contexts/user_context';
import { GamesMiniGallery } from './games_mini_gallery';

import coins from '../../assets/coins.png';
import bomb from '../../assets/bomb.png';
import box from '../../assets/box.png';

import './main_page.css';

export const MainPage: FC = () => {
    const navigate = useNavigate();
    const { access_token, spins } = useUserContext();
    const { open_login_dialog } = useAppContext();

    return (
        <div className='main-page'>
            <div className='banner banner-lg fog fog-right violet' onClick={() => navigate('/quests')}>
                <div className='banner-content'>
                    <div className='banner-text'>New claimr quest!</div>
                    <p>Complete quests, get spins, $ and lots of other bonuses!</p>
                    <button className='primary-button'>
                        Claimr rewards! <div className='glow' />
                    </button>
                </div>
                <div className='cover-container'>
                    <img src={box} alt='' style={{ opacity: 0.8 }} />
                </div>
            </div>

            <div className='banner banner-sm fog fog-right yellow' onClick={() => navigate('/games')}>
                <div className='banner-content'>
                    <div className='banner-text'>Play the best games of the season!</div>
                    <p>Explore the best games on wowhaus!</p>

                    <button className='primary-button'>
                        Play now!
                        <div className='glow' />
                    </button>
                </div>
                <div className='cover-container'>
                    <img src={bomb} alt='' style={{ opacity: 0.2 }} />
                </div>
            </div>

            <div
                className='banner banner-sm fog fog-top-left yellow'
                onClick={() => (access_token ? navigate('/lucky-spins') : open_login_dialog())}
            >
                <div className='banner-content'>
                    <div className='banner-text horizontal-between fill'>
                        <span>Test your luck!</span>
                        {access_token && <span className='badge bounce'>Spins: {spins}</span>}
                    </div>
                    <p>Spin the wheel of fortune, win cool prizes!</p>

                    <button className='primary-button'>
                        {access_token ? 'Spin the wheel!' : 'Login to start'}
                        <div className='glow' />
                    </button>
                </div>
                <div className='cover-container'>
                    <img src={coins} alt='' style={{ opacity: 0.5 }} />
                </div>
            </div>
            <h3>Games:</h3>
            <GamesMiniGallery filter={[]} />
        </div>
    );
};
